"use client";

import type { FeedItems } from "../../../types/content/feedItem";

import { isArticleFeedItem, isInjectable } from "../../../utils/typechecks";
import { InjectablePlaceholder } from "../../Injectable";
import { LatestNewsArticleCluster } from "./LatestNewsArticleCluster/LatestNewsArticleCluster";
import { LatestNewsBoxCluster } from "./LatestNewsBoxCluster/LatestNewsBoxCluster";
import styles from "./LatestNewsLayout.module.scss";

const LatestNewsLayout = ({
  data,
  isFirstFeed,
  isLoggedIn,
}: {
  data: FeedItems;
  isFirstFeed?: boolean;
  isLoggedIn?: boolean;
}) => {
  return (
    <div className={styles.container}>
      {data.map((feedItem, clusterIndex) => {
        if (!feedItem) return null;

        if (isInjectable(feedItem)) {
          return (
            <div
              className={styles.injectableItem}
              key={`${feedItem.type}${clusterIndex}`}
            >
              <InjectablePlaceholder
                resource={feedItem}
                feedLayoutType="latest"
              />
            </div>
          );
        }

        const isFirstElement = clusterIndex === 0;
        const hasBoxAfter = data?.[clusterIndex + 1]?.type === "Box";
        const hasBoxBefore = data?.[clusterIndex - 1]?.type === "Box";

        const teaserWeight = feedItem.weight;

        if (feedItem.type === "Box") {
          return (
            <div
              className={styles.boxItem}
              key={`${feedItem.id}${clusterIndex}`}
            >
              <LatestNewsBoxCluster
                boxGroup={feedItem}
                positionInFeed={clusterIndex + 1}
                teaserWeight={teaserWeight}
              />
            </div>
          );
        }

        if (isArticleFeedItem(feedItem)) {
          const shouldPrioritizeImageLoad = clusterIndex > 3 && isFirstFeed;
          return (
            <div
              className={styles.articleItem}
              key={`${feedItem.id}${clusterIndex}`}
            >
              <LatestNewsArticleCluster
                feedItem={feedItem}
                isLoggedIn={isLoggedIn}
                shouldPrioritizeImageLoad={shouldPrioritizeImageLoad}
                isLastElement={hasBoxAfter}
                isFirstElement={isFirstElement || hasBoxBefore}
                positionInFeed={clusterIndex + 1}
                teaserWeight={teaserWeight}
              />
            </div>
          );
        }
      })}
    </div>
  );
};

export { LatestNewsLayout };
